import { render, staticRenderFns } from "./loginCheck.vue?vue&type=template&id=66c9f980&"
import script from "./loginCheck.vue?vue&type=script&lang=js&"
export * from "./loginCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports